<template>
  <div v-if="me" class="sign-terms">
    <p class="title">
      <span class="font-weight-bold">{{ year }}</span
      >년 <span class="font-weight-bold">{{ month }}</span
      >월 <span class="font-weight-bold">{{ day }}</span
      >일
    </p>
    <p class="title">
      성명
      <strong>{{ me.name }}</strong>
    </p>

    <SignatureDialog :username="me.name" @emitSignSuccess="(v) => sign(v)">
      <template v-slot:activator="{ on }">
        <div v-ripple v-on="on" class="sign-box" :class="{ camera: cameraMode }">
          <p v-if="!signImg" class="sign-guide">서명은 신청인 이름 세 글자로 작성해주세요.</p>
          <img v-else :src="signImg" />
        </div>
      </template>
    </SignatureDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SignatureDialog from '@/components/dialog/SignatureDialog.vue'

// Function Section
function dataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(',')
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export default {
  props: {
    cameraMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SignatureDialog,
  },
  data() {
    return {
      date: new Date(),
      signImg: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    year() {
      const yyyy = this.date.getFullYear()
      return yyyy
    },
    month() {
      const mm = this.date.getMonth() + 1
      return mm
    },
    day() {
      const dd = this.date.getDate()
      return dd
    },
  },
  methods: {
    sign(data) {
      this.signImg = data
      this.$emit('setSignature', dataURIToBlob(data))
    },
  },
}
</script>

<style lang="scss" scoped>
.sign-terms {
  width: 100%;

  .title {
    width: 100%;
    text-align: center;
    line-height: 26px;
  }
  .sign-box {
    width: 100%;
    height: 18vh;
    border-radius: 4px;
    box-shadow: 0 8px 18px 0 rgba(32, 35, 36, 0.08);
    text-align: center;

    margin: 20px 0 30px 0;

    &.camera {
      box-shadow: unset;
    }

    .sign-guide {
      line-height: 18vh;
      color: #8a94a2;
    }

    img {
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
